import prepareGroupSyncConfig from "./prepareGroupSyncConfig";
const prepareLoadGroupsPayload = (prepareAuthBackendPayload, formValues, backendId, serviceType) => {
  const teamSyncAuthBackendId = backendId != null ? backendId : "<test>";
  const directoryServiceConfig = prepareAuthBackendPayload();
  const groupSyncConfig = prepareGroupSyncConfig(formValues, teamSyncAuthBackendId, serviceType);
  return {
    auth_service_backend_id: backendId,
    auth_service_backend_configuration: {
      ...directoryServiceConfig
    },
    team_sync_backend_configuration: groupSyncConfig
  };
};
export default prepareLoadGroupsPayload;
